import React from 'react';
import CountUp from 'react-countup';
import './Fun.css'
import Fade from 'react-reveal/Fade';
const Fun = () => {
    return (
        <div className="container mt-5">
            <div className="row">
                <h3 className=""><span style={{ borderBottom: '3px solid green' }}>FUN FACTS</span></h3>
                <div className="col-md-4 mt-5 justify-content-center align-items-center d-flex">
                    <div className="rounded-3 card-demos" style={{ boxShadow: '0 0 10px grey' }}>
                        <Fade left>
                            <div className="p-5" >
                                <div>
                                    <i className="far fa-smile fa-2x justify-content-center align-items-center d-flex" style={{ color: '#198754' }}></i>
                                </div>
                                <div>
                                    <h5 className="mt-3 text-center"><CountUp start={-10} end={10} duration={10} />+</h5>
                                    <h5 className="text-center">Project Completed</h5>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
                <div className="col-md-4 mt-5 justify-content-center align-items-center d-flex">
                    <div className="rounded-3 card-demos" style={{ boxShadow: '0 0 10px grey' }}>
                        <Fade bottom>
                            <div className="p-5" >
                                <div>
                                    <i className="far fa-clock fa-2x justify-content-center align-items-center d-flex" style={{ color: '#198754' }}></i>
                                </div>
                                <div>
                                    <h5 className="mt-3 text-center"><CountUp end={2000} duration={5} />+</h5>
                                    <h5 className="text-center">Total Hour</h5>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
                <div className="col-md-4 mt-5 justify-content-center align-items-center d-flex">
                    <div className="rounded-3 card-demos" style={{ boxShadow: '0 0 10px grey' }}>
                        <Fade right>
                            <div className="p-5" >
                                <div>
                                    <i className="fas fa-coffee fa-2x justify-content-center align-items-center d-flex" style={{ color: '#198754' }}></i>
                                </div>
                                <div>
                                    <h5 className="mt-3 text-center"><CountUp end={250} duration={10} />+</h5>
                                    <h5 className="text-center">Cup of Coffee</h5>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Fun;